import {BuildingSummary} from "../../../common/model/building-summary";

export class CompactBuildingCard {
  constructor(
    public readonly building: BuildingSummary,
    public readonly notificationCount = 0
  ) {}

  public get guid(): string {
    return this.building.guid;
  }
  
  public get buildingName(): string {
    return this.building.label;
  }
}
